import { CustomError, type ServerResponse } from '@core/utils';
import { captureException } from '@sentry/nextjs';

import { jejuApi } from './jejuApi';

interface TermDetails {
  id: number;
  termsId: string;
  termsName: string;
  termsContent: string;
  termsStartDate: string;
}

interface TermApiResponse extends ServerResponse {
  context: TermDetails[];
}

export const fetchJejuTermList = async () => {
  try {
    const { context } = await jejuApi.get('api001').json<TermApiResponse>();

    return context;
  } catch (error) {
    captureException(error);
    throw new CustomError();
  }
};
